import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SellMoreWorkshop from "@/pages/sell-more-workshop/page";
import AdvertisingPrompts from "@/pages/advertising-prompts/page";
import PhoenixLiteMentoring from "@/pages/phoenix-lite-mentoring/page";
import TrafficPro from "@/pages/traffic-pro/page";
import TrafficMaster from "@/pages/traffic-master/page";
import WebDesign from "@/pages/web-design/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sell-more-workshop",
    element: <SellMoreWorkshop />,
  },
  {
    path: "/advertising-prompts",
    element: <AdvertisingPrompts />,
  },
  {
    path: "/phoenix-lite-mentoring",
    element: <PhoenixLiteMentoring />,
  },
  {
    path: "/traffic-pro",
    element: <TrafficPro />,
  },
  {
    path: "/traffic-master",
    element: <TrafficMaster />,
  },
  {
    path: "/web-design",
    element: <WebDesign />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;